import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import React from "react";
// import {dispatch} from "react-redux"

// context
export const NOTIFICATIONS = "[Notifications]";

// document
export const INSERT_SNACKBAR = `${NOTIFICATIONS} INSERT_SNACKBAR`;
export const SET_SNACKBARS = `${NOTIFICATIONS} SET_SNACKBARS`;

export const CLOSE_SNACKBAR = `${NOTIFICATIONS} CLOSE_SNACKBAR`; // Triggers close action.
export const REMOVE_SNACKBAR = `${NOTIFICATIONS} REMOVE_SNACKBAR`; // Immediately removes from state.

export const addNotification = (
    message,
    variant,
    key= (new Date().getTime() + Math.random()),
    action = undefined
) => ({
    type: INSERT_SNACKBAR,
    key,
    payload: {
       data: {
           message: message,
           options: {
               key: key,
               variant: variant,
               action: action
           },
       }
    }
});

export const closeSnackbar = key => ({
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
});

export const removeSnackbar = key => ({
    type: REMOVE_SNACKBAR,
    key,
});
